import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormModule } from '@woolworthsnz/form';
import { ProductModule } from '@woolworthsnz/product';
import { MARKDOWN_PROVIDER, StyleguideModule } from '@woolworthsnz/styleguide';
import { marked } from 'marked';
import { LottieModule } from 'ngx-lottie';
import { ShareModule } from 'ngx-sharebuttons';
import {
	GridContainerComponent,
	LatestMealPlanComponent,
	LatestMealPlanWidgetComponent,
	NoMealPlansComponent,
	PastMealPlansComponent,
	PrintMealPlanRecipesComponent,
	RecipeOverlappingImagesComponent,
	StampBasicComponent,
} from './components';
import { AddIngredientsModalComponent } from './components/add-ingredients-modal/add-ingredients-modal.component';
import { BadgeComponent } from './components/badge/badge.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CategoryNavComponent } from './components/category-nav/category-nav.component';
import { ChoosePlanModalComponent } from './components/choose-meal-plan/choose-meal-plan-modal.component';
import { ContributorComponent } from './components/contributor/contributor.component';
import { DetailsHeaderComponent } from './components/details-header/details-header.component';
import { GridComponent } from './components/grid/grid.component';
import { IngredientGridComponent } from './components/ingredient-grid/ingredient-grid.component';
import { IngredientStampComponent } from './components/ingredient-stamp/ingredient-stamp.component';
import { MealPlanDietaryPreferenceComponent } from './components/meal-plan-dietary-preference/meal-plan-dietary-preference.component';
import { MealPlanHouseholdPreferenceComponent } from './components/meal-plan-household-preference/meal-plan-household-preference.component';
import { MealPlanModifyPreferencesComponent } from './components/meal-plan-modify-preferences/meal-plan-modify-preferences.component';
import { MealPlanPreferencesBarComponent } from './components/meal-plan-preferences-bar/meal-plan-preferences-bar.component';
import { MealPlanShortlistMealComponent } from './components/meal-plan-shortlist-meal/meal-plan-shortlist-meal.component';
import { MealPlanShortlistComponent } from './components/meal-plan-shortlist/meal-plan-shortlist.component';
import { MealTimesComponent } from './components/meal-times/meal-times.component';
import { MethodComponent } from './components/method/method.component';
import { NutritionalInfoComponent } from './components/nutritional-info/nutritional-info.component';
import { PrepSummaryComponent } from './components/prep-summary/prep-summary.component';
import { ResultsHeaderComponent } from './components/results-header/results-header.component';
import { SeoComponent } from './components/seo/seo.component';
import { ShareModalComponent } from './components/share-modal/share-modal.component';
import { SortHeaderComponent } from './components/sort-header/sort-header.component';
import { StampComponent } from './components/stamp/stamp.component';
import { RecipeTimePipe } from './pipes/recipe-time.pipe';
import { RecipeBreadcrumbService, RecipeService } from './services';

const components = [
	AddIngredientsModalComponent,
	BadgeComponent,
	BreadcrumbComponent,
	ChoosePlanModalComponent,
	ResultsHeaderComponent,
	CategoryNavComponent,
	ContributorComponent,
	DetailsHeaderComponent,
	GridComponent,
	GridContainerComponent,
	IngredientGridComponent,
	IngredientStampComponent,
	MealTimesComponent,
	MethodComponent,
	NutritionalInfoComponent,
	PrepSummaryComponent,
	SeoComponent,
	ShareModalComponent,
	SortHeaderComponent,
	StampComponent,
	LatestMealPlanComponent,
	LatestMealPlanWidgetComponent,
	MealPlanShortlistComponent,
	MealPlanShortlistMealComponent,
	MealPlanPreferencesBarComponent,
	MealPlanModifyPreferencesComponent,
	MealPlanHouseholdPreferenceComponent,
	MealPlanDietaryPreferenceComponent,
	NoMealPlansComponent,
	PastMealPlansComponent,
	PrintMealPlanRecipesComponent,
	RecipeOverlappingImagesComponent,
	StampBasicComponent,
];
const pipes = [RecipeTimePipe];

@NgModule({
	imports: [
		CommonModule,
		StyleguideModule,
		ShareModule,
		RouterModule,
		FormModule,
		ReactiveFormsModule,
		ProductModule,
		LottieModule,
		...components,
		...pipes
	],
	exports: [...components],
	providers: [
		{
			provide: MARKDOWN_PROVIDER,
			useValue: marked,
		},
		RecipeService,
		RecipeBreadcrumbService,
		RecipeTimePipe,
		FormGroupDirective,
	]
})
export class RecipeModule { }
